import _createForOfIteratorHelper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ConnectionMessage, Deferred, MessageType, RawWebsocketMessage } from "../common/Exports";
var CRLF = "\r\n";
export var WebsocketMessageFormatter = function WebsocketMessageFormatter() {
  var _this = this;

  _classCallCheck(this, WebsocketMessageFormatter);

  this.toConnectionMessage = function (message) {
    var deferral = new Deferred();

    try {
      if (message.messageType === MessageType.Text) {
        var textMessage = message.textContent;
        var headers = {};
        var body = null;

        if (textMessage) {
          var headerBodySplit = textMessage.split("\r\n\r\n");

          if (headerBodySplit && headerBodySplit.length > 0) {
            headers = _this.parseHeaders(headerBodySplit[0]);

            if (headerBodySplit.length > 1) {
              body = headerBodySplit[1];
            }
          }
        }

        deferral.resolve(new ConnectionMessage(message.messageType, body, headers, message.id));
      } else if (message.messageType === MessageType.Binary) {
        var binaryMessage = message.binaryContent;
        var _headers = {};
        var _body = null;

        if (!binaryMessage || binaryMessage.byteLength < 2) {
          throw new Error("Invalid binary message format. Header length missing.");
        }

        var dataView = new DataView(binaryMessage);
        var headerLength = dataView.getInt16(0);

        if (binaryMessage.byteLength < headerLength + 2) {
          throw new Error("Invalid binary message format. Header content missing.");
        }

        var headersString = "";

        for (var i = 0; i < headerLength; i++) {
          headersString += String.fromCharCode(dataView.getInt8(i + 2));
        }

        _headers = _this.parseHeaders(headersString);

        if (binaryMessage.byteLength > headerLength + 2) {
          _body = binaryMessage.slice(2 + headerLength);
        }

        deferral.resolve(new ConnectionMessage(message.messageType, _body, _headers, message.id));
      }
    } catch (e) {
      deferral.reject("Error formatting the message. Error: ".concat(e));
    }

    return deferral.promise();
  };

  this.fromConnectionMessage = function (message) {
    var deferral = new Deferred();

    try {
      if (message.messageType === MessageType.Text) {
        var payload = "".concat(_this.makeHeaders(message)).concat(CRLF).concat(message.textBody ? message.textBody : "");
        deferral.resolve(new RawWebsocketMessage(MessageType.Text, payload, message.id));
      } else if (message.messageType === MessageType.Binary) {
        var headersString = _this.makeHeaders(message);

        var content = message.binaryBody;
        var headerInt8Array = new Int8Array(_this.stringToArrayBuffer(headersString));

        var _payload = new ArrayBuffer(2 + headerInt8Array.byteLength + (content ? content.byteLength : 0));

        var dataView = new DataView(_payload);
        dataView.setInt16(0, headerInt8Array.length);

        for (var i = 0; i < headerInt8Array.byteLength; i++) {
          dataView.setInt8(2 + i, headerInt8Array[i]);
        }

        if (content) {
          var bodyInt8Array = new Int8Array(content);

          for (var _i = 0; _i < bodyInt8Array.byteLength; _i++) {
            dataView.setInt8(2 + headerInt8Array.byteLength + _i, bodyInt8Array[_i]);
          }
        }

        deferral.resolve(new RawWebsocketMessage(MessageType.Binary, _payload, message.id));
      }
    } catch (e) {
      deferral.reject("Error formatting the message. ".concat(e));
    }

    return deferral.promise();
  };

  this.makeHeaders = function (message) {
    var headersString = "";

    if (message.headers) {
      for (var header in message.headers) {
        if (header) {
          headersString += "".concat(header, ": ").concat(message.headers[header]).concat(CRLF);
        }
      }
    }

    return headersString;
  };

  this.parseHeaders = function (headersString) {
    var headers = {};

    if (headersString) {
      var headerMatches = headersString.match(/[^\r\n]+/g);

      if (headers) {
        var _iterator = _createForOfIteratorHelper(headerMatches),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var header = _step.value;

            if (header) {
              var separatorIndex = header.indexOf(":");
              var headerName = separatorIndex > 0 ? header.substr(0, separatorIndex).trim().toLowerCase() : header;
              var headerValue = separatorIndex > 0 && header.length > separatorIndex + 1 ? header.substr(separatorIndex + 1).trim() : "";
              headers[headerName] = headerValue;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }

    return headers;
  };

  this.stringToArrayBuffer = function (str) {
    var buffer = new ArrayBuffer(str.length);
    var view = new DataView(buffer);

    for (var i = 0; i < str.length; i++) {
      view.setUint8(i, str.charCodeAt(i));
    }

    return buffer;
  };
};